<section class="about-founder-section" *ngIf="section">
  <div class="about-founder-inner">
    <div class="about-founder-photo" aria-label="Founder portrait">
      <img *ngIf="section.imageUrl" [src]="section.imageUrl" [alt]="section.firstName + ' ' + section.lastName">
      <div *ngIf="!section.imageUrl" class="about-founder-placeholder">{{ section.role }} PHOTO</div>
    </div>
    <article class="about-founder-copy">
      <p class="about-founder-eyebrow">{{ section.sectionEyebrow }}</p>
      <h2>
        <span>{{ section.firstName }}</span>
        <span class="about-founder-accent">{{ section.lastName }}</span>
      </h2>
      <p class="about-founder-role" *ngIf="section.role">{{ section.role }}</p>
      <p class="about-founder-paragraph" *ngFor="let paragraph of section.bio">{{ paragraph }}</p>
      <blockquote>
        {{ section.highlight }}
        <span *ngIf="section.highlightAttribution">{{ section.highlightAttribution }}</span>
      </blockquote>
    </article>
  </div>
</section>
